import React ,{ useState, useEffect  }from 'react'
import Table from 'react-bootstrap/Table';
import { FaPlusCircle, FaEdit, FaTrash } from 'react-icons/fa';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { useSignalAbort } from '../../api/useSignalAbort';
import { handleApiErrors } from "../../api/handleApiErrors";
import * as blogApi from './../../api/blogApi';
import { Spinner } from 'react-bootstrap';
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const defaultBlogDetails = {
  Title: '',
  Content: '',
  Image: '',
  ExternalUrl: '',
  IsActive: 1,
   
}

function BlogTable() {
  const abortConstants = useSignalAbort()
  const [isLoading, setIsLoading] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
   const [blogDetails, setBlogDetails] = useState(defaultBlogDetails);
  const [blogList, setBlogList] = useState([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [blogToDelete, setBlogToDelete] = useState(null);
  
  const [validated, setValidated] = useState(false);
const [errors, setErrors] = useState({});


  useEffect(() => {
    getAllData(abortConstants.controllerConfig)
  },[])


  const getAllData = (abortToken) => {
    getAllBlog(abortToken)
  }
  

//Bloglist
const getAllBlog = async (abortToken) => {
  try {
     const result = await blogApi.getBlog(abortToken)
    
    setBlogList(result.data.Blogs)
    console.log(result.data.Blogs);
  }
  catch (error) {
     console.log(error);
     handleApiErrors(error, 'BlogsListing', 'blogsListing_response', 'blogsListing_timeout', 'blogsListing_request', setIsLoading);

  }
}


//for add job api call
const createBlog = async (data,abortToken) => {
  console.log(data);
  try {
     const result = await blogApi.createBlog(data,abortToken)

     if(result){
      setIsLoading(false);
    }

    //  toast.success(result.data.message)
    toast.success("Blog created successfully!", {
      autoClose: 5000, // Close the toast after 5 seconds
    });
    
    console.log(result);
  }
  catch (error) {
    console.log(error);
    toast.error(error)
    handleApiErrors(error, 'BlogsListing', 'blogsListing_response', 'blogsListing_timeout', 'blogsListing_request', setIsLoading);
    setIsLoading(false);
   }
}


//for   UPDATE api call
const updateBlog = async (id,data,abortToken) => {
  console.log("edit",id,data);
  try {
     const result = await  blogApi.updateBlog(id,data,abortToken)

     if(result){
      setIsLoading(false);
    }

//  toast.success(result.data.message)
toast.success("Blog updated successfully!", {
autoClose: 5000, // Close the toast after 5 seconds
});
     console.log(result);

  }
  catch (error) {
    console.log(error);
    toast.error(error)
    handleApiErrors(error, 'BlogsListing', 'blogsListing_response', 'blogsListing_timeout', 'blogsListing_request', setIsLoading);
    setIsLoading(false);

  }
}

const deleteBlog = async (id) => {
  setBlogToDelete(id);
  setShowDeleteModal(true);
};

const handleDeleteBlog = async () => {
  try {
    await blogApi.deleteBlog(blogToDelete);
    const updatedBlogList = blogList.filter((blog) => blog.BlogsId !== blogToDelete,abortConstants.controllerConfig);
    
    //  toast.success(result.data.message)
    toast.success("Blog deleted successfully!", {
      autoClose: 5000, // Close the toast after 5 seconds
    });

    setBlogList(updatedBlogList);
    setShowDeleteModal(false);
  } catch (error) {
    console.log(error);
    toast.error(error)
    handleApiErrors(error, 'BlogListing', 'blogListing_response', 'blogListing_timeout', 'blogListing_request', setIsLoading);

  }
};

const handleCancelDelete = () => {
  setShowDeleteModal(false);
  setBlogToDelete(null);
};



 // Handle image change
//  const handleLogoChange = (e) => {
//   const file = e.target.files[0];
//   const reader = new FileReader();

//   reader.onload = () => {
//     try {
//       const base64Data = reader.result.split(',')[1]; // Get base64 data excluding the data URI scheme
//       setBlogDetails({
//         ...blogDetails,
//         Image: base64Data
       
//       });
//      } catch (error) {
//       console.error('Error handling image data:', error);
//       // Handle the error (e.g., show an error message to the user)
//     }
//   };

//   reader.readAsDataURL(file);
//   setSelectedLogo(file);
// };
const handleLogoChange = (e) => {
  const file = e.target.files[0];
  const reader = new FileReader();

  reader.onload = () => {
    try {
      const base64Data = reader.result.split(',')[1];
      if (/^[a-zA-Z0-9+/]*={0,2}$/.test(base64Data)) {
      setBlogDetails({
        ...blogDetails,
        Image: base64Data
      });
      setSelectedLogo(reader.result); // Update selectedLogo with the data URL
    } else {
      console.error('Invalid base64 data');
    }
  }catch (error) {
      console.error('Error handling image data:', error);
    }
  };

  reader.readAsDataURL(file);
};



  // Toggle add modal
  const toggleAddModal = () => {
    setShowAddModal(!showAddModal);
    if (!showAddModal) {
      resetBlogDetails();
    }
  };

 

  // Handle input change in blog details
  const handleChange = (e) => {
    if (e.target.name === 'IsActive') {
      setBlogDetails({ ...blogDetails, IsActive: e.target.checked ? 1 : 0 });
    } else {
      setBlogDetails({ ...blogDetails, [e.target.name]: e.target.value });
    }
  };
 

  // Toggle edit modal
  const toggleEditModal = (index) => {
    console.log(index);
    const blog_id = blogList[index]?.BlogsId
    
    setEditIndex(blog_id);
    if (!showEditModal) {
      setBlogDetails(blogList[index]); 
      setSelectedLogo(`${process.env.REACT_APP_BASE_URL}${blogList[index]?.Image}`)

    }
        setShowEditModal(!showEditModal);
        console.log(blogList[index]);
  };

console.log(blogDetails);



  // Reset job details
  const resetBlogDetails = () => {
    setBlogDetails(defaultBlogDetails); // Reset to default values
    setSelectedLogo(null);
  };


// Handle add form submit
const handleSubmit = (e) => {
  setIsLoading(true);
  e.preventDefault();

  const form = e.currentTarget;
  
  if (form.checkValidity() === false) {
    e.stopPropagation();
    setValidated(true);
    setIsLoading(false);

    return;
  }

  let newData = {
    ...blogDetails,
    
    }

  console.log(newData);
console.log(selectedLogo);

const handleCreateBlog = async () => {
    try {
      await createBlog(newData,abortConstants.controllerConfig);
      toggleAddModal(); // Close the modal
      setBlogList([...blogList,newData]);
    } catch (error) {
      console.log(error);
    }
  };

  handleCreateBlog(); // Call the asynchronous function
};


// Handle Edit form submit
const handleEditSubmit = async  (e) => {
  setIsLoading(true);
  e.preventDefault();

  const form = e.currentTarget;
  
  if (form.checkValidity() === false) {
    e.stopPropagation();
    setValidated(true);
    setIsLoading(false);

    return;
  }

  let newData = {
    ...blogDetails,
     
  }
  console.log(blogDetails);

  try {
    // Send request to update blog data in the backend
    await updateBlog(editIndex, newData,abortConstants.controllerConfig);

    // Update local state (jobList) with the edited data
    const updatedBlogList = blogList.map((blog, index) =>
      index === editIndex ? newData : blog
    );
    setBlogList(updatedBlogList);

    // Close the edit modal
    toggleEditModal();
  } catch (error) {
    console.log(error);
  }
};


const renderLoading = (item) => {
    if (isLoading[`${item}_response`] || isLoading[`${item}_request`] || isLoading[`${item}_timeout`]) {
      return true;
    } else {
      return false;
    }
  }



  return (
<div style={{margin :'20px' ,width:'100%'}}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '0' }}>Blogs</h2>
        <FaPlusCircle size={24} style={{ marginBottom: '10px' ,color:'#172446', cursor: 'pointer'}} onClick={toggleAddModal}/>
      </div>
      
      
      {/* add blog Modal */}
<Modal show={showAddModal} onHide={toggleAddModal}  backdrop="static">
        <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa' }}>
          <Modal.Title style={{color:'#172446',fontFamily:'segoe ui'}}>Add Blog</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: '#f8f9fa' }}>
        <Form noValidate validated={validated} onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
          

{/* row 1 -  title*/}
 <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="Title">
        <Form.Label style={{ marginBottom: '5px' }}>Title</Form.Label>
        <Form.Control name="Title" placeholder="Title" value={blogDetails.Title} onChange={handleChange} required isInvalid={errors.Title} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid Title.</Form.Control.Feedback>
      </Form.Group>
    </div>
</div>

{/* row 2 - Content */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="Content">
        <Form.Label style={{ marginBottom: '5px' }}>Content</Form.Label>
        <Form.Control as="textarea"  rows={4} name="Content" placeholder="Content" value={blogDetails.Content} onChange={handleChange} required isInvalid={errors.Content} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%' }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid Content.</Form.Control.Feedback>
      </Form.Group>
    </div>
</div>

 
{/* row 4 - Image */}

<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
          <div style={{ marginRight: '10px', flex: '1' }}>
          <label htmlFor="logo" style={{ marginBottom: '5px' }}>Image</label>
          <input type="file" accept="image/png" id="logo" name="logo" onChange={handleLogoChange} style={{ display: 'none' }} />
          <label htmlFor="logo" style={{ display: 'block', width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', cursor: 'pointer' }}>
           {selectedLogo ? <img src={selectedLogo} alt="Selected" style={{ maxWidth: '100%', maxHeight: '150px' }} /> : 'Choose File'}
          </label>
          </div>
</div> 

{/* row 3 - ExternalUrl */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="ExternalUrl">
        <Form.Label style={{ marginBottom: '5px' }}>Blog Link</Form.Label>
        <Form.Control name="ExternalUrl" placeholder="ExternalUrl" value={blogDetails.ExternalUrl} onChange={handleChange} required isInvalid={errors.ExternalUrl} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid Link</Form.Control.Feedback>
      </Form.Group>
    </div>
</div>

        <div className="d-flex justify-content-end mt-3">
        <button type="submit" className="btn" style={{marginRight:'20px',backgroundColor:'#172446', color:'#fff'}}> 
        {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              
              Saving...
            </>
          ) : (
         'Save'
    )}
        </button>
     
        <button type="button" className="btn btn-secondary" onClick={toggleAddModal} style={{marginRight:'20px',  color:'#000'}}>Cancel</button>
      </div>
      </Form>
        </Modal.Body>
      
      </Modal>


{/* Edit Job Modal */}
      <Modal show={showEditModal} onHide={toggleEditModal} backdrop="static">
<Modal.Header closeButton style={{ backgroundColor: '#f8f9fa' }}>
          <Modal.Title style={{color:'#172446',fontFamily:'segoe ui'}}> Edit Blog </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: '#f8f9fa' }}> 
             
          <Form noValidate validated={validated} onSubmit={handleEditSubmit} style={{ display: 'flex', flexDirection: 'column' }}>

{/* row 1 -  title , isactive*/}
 <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="Title">
        <Form.Label style={{ marginBottom: '5px' }}>Title</Form.Label>
        <Form.Control name="Title" placeholder="Title" value={blogDetails.Title} onChange={handleChange} required isInvalid={errors.Title} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid Title.</Form.Control.Feedback>
      </Form.Group>
    </div>

    <div style={{ flex: '1' }}>
          <label style={{ marginBottom: '5px' ,marginLeft:'50px'}}>Status</label>
          <div style={{ display: 'flex', alignItems: 'center',marginLeft:'50px',marginTop:'10px' }}>
          <Form.Check
  type="switch"
  id="custom-switch"
  label="Active"
  checked={blogDetails.IsActive === 1}
  onChange={() => setBlogDetails({ ...blogDetails, IsActive: blogDetails.IsActive === 1 ? 0 : 1 })}
/>
 </div>
</div>

 </div>

{/* row 2 - Content */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="Content">
        <Form.Label style={{ marginBottom: '5px' }}>Content</Form.Label>
        <Form.Control as="textarea"  rows={4} name="Content" placeholder="Content" value={blogDetails.Content} onChange={handleChange} required isInvalid={errors.Content} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%'  }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid Content.</Form.Control.Feedback>
      </Form.Group>
    </div>
</div>

 
{/* row 4 - Image */}

     <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
          <div style={{ marginRight: '10px', flex: '1' }}>
          <label htmlFor="logo" style={{ marginBottom: '5px' }}>Image</label>
          <input type="file" accept="image/png" id="logo" name="logo" onChange={handleLogoChange} style={{ display: 'none' }} />
          <label htmlFor="logo" style={{ display: 'block', width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', cursor: 'pointer' }}>
           {selectedLogo ? <img src={selectedLogo} alt="Selected" style={{ maxWidth: '100%', maxHeight: '150px' }} /> : 'Choose File'}
          </label>
          </div>
        </div> 

{/* row 3 - ExternalUrl */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="ExternalUrl">
        <Form.Label style={{ marginBottom: '5px' }}>Blog Link</Form.Label>
        <Form.Control name="ExternalUrl" placeholder="ExternalUrl" value={blogDetails.ExternalUrl} onChange={handleChange} required isInvalid={errors.ExternalUrl} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid Link</Form.Control.Feedback>
      </Form.Group>
    </div>
</div>

<div className="d-flex justify-content-end mt-3">
        <button type="submit" className="btn" style={{marginRight:'20px',backgroundColor:'#172446', color:'#fff'}}> 
        {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              
              Updating...
            </>
          ) : (
         'Update changes'
    )}
        </button>
     
        <button type="button" className="btn btn-secondary" onClick={toggleEditModal} style={{marginRight:'20px',  color:'#000'}}>Cancel</button>
      </div>
  
        </Form>        
        </Modal.Body>

      </Modal>






{renderLoading("blogsListing") || blogDetails==null?(
  <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
  {blogDetails === null ? "No data" : <Spinner animation="border" role="status" style={{ color: '#2855A1' }} />}
</div>
):(
  <div style={{height:'600px',overflow:'auto' ,marginTop: '20px'}}>
 

 <Table striped bordered hover style={{ marginTop: '20px' }}>

<thead>
  <tr>
     <th>Title</th>
    <th>Content</th>
     <th>Image</th>
    <th>Blog Link</th>
    <th>Status</th> 
    <th>Actions</th>  

  </tr>
</thead>

<tbody>
    {blogList?.map((Blog, index) => (
      <tr key={index}>
         <td>{Blog.Title}</td>
        <td>{Blog.Content}</td>

        <td>
          {/* {Blog.Image} */}
        {Blog.Image && (
          <img src={`${process.env.REACT_APP_BASE_URL}${Blog.Image}`}  alt="Image" style={{ maxWidth: '50px', maxHeight: '50px' }}/>
        )}
        </td>

        <td>{Blog.ExternalUrl}</td>

        <td>{Blog.IsActive === 1 ? 'Active' : 'InActive'}</td>        

         <td>
         <FaEdit
            style={{ marginRight: '5px', color: '#172446', cursor: 'pointer' }}
            onClick={() => toggleEditModal(index)} // Update to toggleEditModal
         />     
          <FaTrash
            style={{ marginLeft: '15px', color: 'red', cursor: 'pointer' }}
            onClick={() => { deleteBlog(Blog.BlogsId) }}
            />

<Modal show={showDeleteModal} onHide={handleCancelDelete} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this Blog?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDelete}>Cancel</Button>
          <Button variant="danger" onClick={handleDeleteBlog}>Delete</Button>
        </Modal.Footer>
      </Modal>  


        
        </td>
      </tr>
    ))}
  </tbody>

</Table>

 </div>
)

}





   
    </div>
        )
}

export default BlogTable